import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const SubgraphTriggerDetails = ({ trigger, triggerType }: Props) => {
  const subgraphName = useMemo(() => {
    if (trigger.context?.subgraphName) {
      return trigger.context.subgraphName;
    }

    if (trigger.signature) {
      const match = trigger.signature.match(/^SubgraphBalance-(.+)$/);
      return match ? match[1] : '';
    }

    return '';
  }, [trigger.context?.subgraphName, trigger.signature]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetail label="Subgraph Name" value={subgraphName} />
    </div>
  );
};
